import styled, { css } from 'styled-components';
import { StyledSectionContainer } from '../../globalStyled';
import { ReactComponent as ArrowRed } from '../../assets/img/arrow-red.svg';
import { ReactComponent as ArrowGreen } from '../../assets/img/arrow-green.svg';
import { fontDisplay, fontUi } from '../../theme/typography';

export const StyledBalanceWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 210px;
  margin-right: 20px;
  @media only screen and (max-width: 1199px) {
    flex-direction: row;
    max-width: 100%;
    width: 100%;
    justify-content: space-between;
  }
`;
export const StyledBalanceContainer = styled(StyledSectionContainer)`
  padding: 20px 20px 16px;
  max-width: 210px;
  margin-bottom: 15px;
  @media only screen and (max-width: 1199px) {
    max-width: 48%;
    display: flex;
    flex-direction: column-reverse;
    align-items: center;
  }
`;
export const StyledCashContainer = styled(StyledSectionContainer)`
  padding: 20px 20px 16px;
  max-width: 210px;
  @media only screen and (max-width: 1199px) {
    max-width: 48%;
    padding: 0;
    background-color: transparent;
    box-shadow: none;
    border: 0;
    margin-bottom: 15px;
  }
`;

export const StyledBalanceLabel = styled.span`
  ${fontUi};
  font-size: 12px;
  color: ${({ theme }) => theme.textFaint};
  text-transform: uppercase;
  margin-bottom: 15px;
  ${({ isOut, theme }) => {
    if (isOut) {
      return css`
        margin-top: 25px;
        color: ${theme.danger};
        font-weight: 600;
        @media only screen and (max-width: 1199px) {
          margin-top: 0;
        }
      `;
    }
  }};
  ${({ isIn, theme }) => {
    if (isIn) {
      return css`
        color: ${theme.success};
        font-weight: 600;
      `;
    }
  }};
`;

export const StyledArrowRed = styled(ArrowRed)`
  margin-right: 5px;
`;
export const StyledArrowGreen = styled(ArrowGreen)`
  margin-right: 5px;
`;

export const StyledBalanceAmount = styled.span`
  ${fontDisplay};
  font-size: 22px;
  letter-spacing: -0.02em;
  color: ${({ theme }) => theme.text};
`;
export const StyledCash = styled.span`
  ${fontUi};
  color: ${({ theme }) => theme.textMuted};
  font-size: 16px;
  font-weight: 600;
`;

export const StyledCashBlock = styled.div`
  display: flex;
  flex-direction: column;
  @media only screen and (max-width: 1199px) {
    background-color: ${({ theme }) => theme.card};
    border: 1px solid ${({ theme }) => theme.border};
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.04);
    border-radius: ${({ theme }) => theme.cardRadius};
    padding: 12px;
    align-items: center;
    &:first-of-type {
      margin-bottom: 15px;
    }
  }
`;
export const StyledPreloaderContainer = styled.div`
  background-color: ${({ theme }) => theme.card};
  border-radius: ${({ theme }) => theme.cardRadius};
  margin-bottom: 20px;
  ${({ isMobile }) => {
    if (isMobile) {
      return css`
        flex-direction: column;
        width: 49%;
        align-items: center;
        display: flex;
      `;
    }
  }}
`;
